<template>
  <div v-if="list_packs_courses.list && list_packs_courses.list.length > 0">
    <div class="d-flex flex-start gap align-center bg-spo-blue-grey px-2 py-2 radius-bottom mt-5">
      <v-icon icon="mdi-clipboard-multiple" color="darkblue" size="32"></v-icon>
      <div class="text-h5 font-weight-bold">Les packs de courses</div>
    </div>
    <PackItem :pack="pack" v-for="pack in list_packs_courses.list" :key="pack.id"></PackItem>
    <InscriptionGateDialogs />
    <v-divider></v-divider>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import PackItem from "@/components/Home/Packs/Pack_Item.vue";
import InscriptionGateDialogs from "@/components/Home/InscriptionGateDialogs.vue";
export default {
  components: { PackItem, InscriptionGateDialogs },
  data() {
    return {
    };
  },
  computed: {
    ...mapStores(useMainStore),
    list_packs_courses() {
      return this.mainStore.module.packs_courses;
    }
  },
};
</script>

<style lang="scss" scoped></style>